const goneawaySuppressionPageData = {
  slug: "goneaway-suppression",
  title: "Goneaway Suppression",
  introduction:
    "We identify customers who have moved home — removing unreachable individuals from your database and providing verified new forwarding addresses to keep you connected.",
  hero: {
    eyebrow: "Suppression Services",
    align: "left",

    highlights: [
      { value: "6%", label: "of the UK population moves home every month" },
    ],
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "key-fact",
      variant: "feature",
      stat: "6x",
      title:
        "Acquiring a new customer can cost six times more than retaining an existing one",
      content: [
        "When people move home, they're actively spending on new products and services — often switching to new suppliers. Don't miss your opportunity to retain valuable customers during their moving process. Our goneaway suppression helps you stay ahead of these transitions.",
      ],
    },

    {
      id: "identify-home-movers",
      title: "Identify Home Movers",
      titleDivider: true,
      content: [
        "Data accuracy has never been more important. GDPR Article 5.1d makes data accuracy a legal requirement. Our suppression services help you to identify known movers and goneaways to keep your data accurate.",
        "Our services identify home movers using enhanced and accurate suppression files. We use intelligent transactional and relational data sources along with official Government data to cross-match and confirm known movers. Our service helps you to maximise the effectiveness of marketing campaigns and reduce wasted marketing spend.",
      ],
    },
    {
      id: "opportunity",
      title: "The Opportunity in Home Movers",
      titleDivider: true,
      content: [
        "People on the move are actively buying. Don't let them slip out of your reach.",
      ],
      highlight: {
        heading: "Why Goneaway Suppression Matters Now",
        items: [
          {
            heading: "Stay Connected",
            text: "In most cases customers won't tell you they're moving — unless legally required to. Our service keeps your data current so contact never lapses unexpectedly.",
          },
          {
            heading: "Reduce Marketable Data Loss",
            text: "Goneaway suppression is a simple, effective way to keep your data clean and avoid having to delete valuable customer records due to inaccuracy.",
          },
        ],
      },
    },
    {
      id: "data-sources-intro",
      title: "Our Data Sources",
      titleDivider: true,
      content: [
        "Multi-source verification for maximum accuracy and confidence.",
      ],
    },
    {
      type: "benefits",
      variant: "chips",
      items: [
        {
          icon: "bank",
          title: "Government Data",
          description: "Official records cross-matched to verify known movers",
        },
        {
          icon: "insights",
          title: "Transactional Data",
          description: "Real behavioural signals from actual consumer activity",
        },
        {
          icon: "calendar",
          title: "Relational Data",
          description: "Linked records identifying confirmed address changes",
        },
        {
          icon: "location",
          title: "Forwarding Addresses",
          description: "Verified new addresses and new occupier details",
        },
      ],
    },
    {
      type: "benefits",
      variant: "outcomes",
      heading: "Benefits of Goneaway Suppression",
      titleDivider: true,
      items: [
        {
          title: "Data Accuracy",
          description:
            "Keep your customer and prospect database accurate — reduce the risk of having to delete data and reduce your marketable data assets.",
        },
        {
          title: "Ease of Implementation",
          description:
            "A simple and effective way to keep your data clean. Quick to integrate into existing data workflows with minimal disruption.",
        },
        {
          title: "Save Time & Money",
          description:
            "Ensure communications go to active people at the right address — eliminating wasted spend on undeliverable mail and digital contacts.",
        },
        {
          title: "GDPR Compliant",
          description:
            "GDPR Article 5.1(d) makes data accuracy a legal requirement. Avoid heavy penalties by ensuring your address data is always current.",
        },
        {
          title: "Retain Valuable Customers",
          description:
            "Stay connected with customers and supporters through life transitions — maintaining relationships that matter to your business.",
        },
        {
          title: "Verified Forwarding",
          description:
            "We can provide verified new addresses and known new occupier details — keeping opportunities alive even when customers move on.",
        },
      ],
    },

    {
      id: "forwarding-cta",
      variant: "feature",
      icon: "location",
      title: "New Address & Occupier Data Available",
      content: [
        "Beyond suppression, we can provide verified forwarding addresses as well as known new occupier details for the same address — turning a potential data loss into a fresh acquisition opportunity.",
      ],
      cta: { label: "Enquire now", href: "#enquiry" },
    },
  ],

  // No fixed pricing model exists for this service.
  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "Goneaway Suppression",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "Goneaway Suppression - Lloyd James Data Consultancy",
    description:
      "Identify home movers and goneaways with our GDPR-compliant suppression service, keeping your marketing data accurate and providing verified forwarding addresses.",
    keywords:
      "goneaway suppression, home movers data, GDPR Article 5.1d, address data accuracy, forwarding addresses, data suppression, Lloyd James",
    canonical: "/goneaway-suppression/",
  },
};

export default goneawaySuppressionPageData;
